import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { callApi } from 'services/apiWrapper';
import { SecureFileRecord } from 'types/SecureFileTypes';

export const secureFileKeys = {
  list: () => ['list'],
};

const fetchSecureFiles = async () => {
  const res = await callApi('/api/files/list', 'GET');
  return res;
};

export const deleteSecureFile = async (fileId: string) => {
  const _res = await callApi(`/api/files/${fileId}/delete`, 'DELETE');
};

export const useSecureFilesList = (
  enabled: boolean,
): UseQueryResult<SecureFileRecord[], Error> => {
  return useQuery({
    queryKey: secureFileKeys.list(),
    queryFn: fetchSecureFiles,
    staleTime: 60 * 5 * 1000,
    enabled: enabled,
  });
};
